import script from "./LocationsProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationsProgress.vue?vue&type=script&setup=true&lang=js"

import "./LocationsProgress.vue?vue&type=style&index=0&id=3264168d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3264168d"]])

export default __exports__